import {Configuration, DefaultApi} from '../api/index'
import * as dotenv from 'dotenv';

import axios from 'axios';

var token  = ""

export default function NewApi() :DefaultApi{
    let t = localStorage.getItem("token")
    if(t == null){
        t = ""
    }
    const apiConfig :Configuration = {
        basePath: basePath,
        accessToken: t,
     };
     return new DefaultApi(apiConfig);
}



dotenv.config();

const host = process.env.VUE_APP_HOST;
const basePath = host + "/v1";

console.log("Basepath is: " + basePath)

export function BasePath(){
    return basePath
}

export function ImagePath(imagename :string){
    return host + "/files/" + imagename
}

export function ImageThumbPath(imagename :string){
    return host + "/files/thumb/" + imagename
}

export function ImageCoverPath(imagename :string){
    return host + "/files/cover/" + imagename
}


export function SetToken(t :string){
    console.log("set token: " + t)
    token = t
    let ts = new Date()
    localStorage.setItem("token", t)
    localStorage.setItem("ts", ts.toUTCString())
}
